<template lang="pug">
#services-list
  .table-view
    .table-view-header
      .table-view-header-title
        h3 Servicios
      .table-view-header-actions
        b-btn.btn-create.boton(@click="showCreateModal()" size="sm" variant="secondary") + Nuevo
    b-table(:fields="fields" :items="tableItems" head-row-variant="light-primary" responsive)
      template(v-slot:cell(Acciones)="data")
        .table-actions
          b-button(@click="goToDetails(data.value.service)", size="sm", variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'edit']" size="lg")
          b-button(@click="showDeleteModal(data.value.service)", size="sm", variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'trash-alt']" size="lg")
  //- Modales
  b-modal(v-model="showCreate", :hide-footer="true", title="Crear Servicio" no-close-on-backdrop)
    create-edit-form(v-if="showCreate", action="create", :hideModal="hideCreateModal", :makeToast="makeToast")
  b-modal(v-model="showDelete", :hide-footer="true", title="Eliminar Servicio" no-close-on-backdrop)
    delete-service(v-if="showDelete", :hideModal="hideDeleteModal", :selectedService="selectedService", :makeToast="makeToast")

</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CreateEditForm from './CreateEditForm';
import DeleteService from './DeleteService';
export default {
  components: {
    CreateEditForm,
    DeleteService
  },
  data() {
    return {
      showCreate: false,
      showDelete: false,
      selectedService: null,
      fields: [
        {
          key: 'Nombre',
          sortable: true
        },
        {
          key: 'Orden',
          sortable: true
        },
        {
          key: 'Día inicio',
          sortable: true
        },
        {
          key: 'Día termino',
          sortable: true
        },
        {
          key: 'Acciones',
        }
      ]
    }
  },
  async created() {
    await this.listServices();
  },
  computed: {
    ...mapGetters(['services']),
    tableItems(){
      if (this.services) {
        return this.services.map((s) => {
          return {
            'Nombre': s.name,
            'Día inicio': s.startMonthDay,
            'Día termino': s.lastMonthDay,
            'Orden': s.order,
            'Acciones': { service: s }
          }
        })
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['listServices']),
    showCreateModal() {
      this.showCreate = true;
    },
    goToDetails(service){
      this.$router.push({name: 'ServiceDetail', params: { id: service.id}});
    },
    showDeleteModal(service){
      this.selectedService = service;
      this.showDelete = true;
    },
    async hideCreateModal() {
      this.showCreate = false;
      await this.listServices();
    },
    async hideDeleteModal() {
      this.showDelete = false;
      await this.listServices();
    },
    makeToast(variant=null, body, title) {
      this.$bvToast.toast(
        body,
        {
          title,
          variant,
          solid: true,
          hide: true,
          autoHideDelay: 3000
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
#services-list {
  margin-top: 20px;
  #addButton {
    margin-bottom: 20px;
  }
  .tableButton {
    margin-right: 5px;
  }
}
</style>